import { z } from "zod";
import { UuidSchema, MoneySchema, EpochMillisSchema } from "./common.js";
/** Guildes (R16, /api/public/guilds). Sources : etheria_guilds, etheria_guild_members. */
export const GuildMemberSchema = z.object({
    uuid: UuidSchema,
    name: z.string().nullable(),
    grade: z.string(),
    online: z.boolean().optional(),
    joinedAt: EpochMillisSchema.nullable(),
});
export const GuildSchema = z.object({
    id: z.number().int(),
    name: z.string(),
    tag: z.string().nullable(),
    description: z.string().nullable(),
    // owner_uuid peut être absent du schéma de la table de guildes sur certaines bases de jeu →
    // nullable pour tolérer une guilde sans propriétaire résolu (le site n'en fait pas une clé dure).
    ownerUuid: UuidSchema.nullable(),
    ownerName: z.string().nullable(),
    balance: MoneySchema,
    level: z.number().int().nonnegative().optional(),
    memberCount: z.number().int().nonnegative(),
    createdAt: EpochMillisSchema.nullable(),
    roster: z.array(GuildMemberSchema),
});
/** Entrée d'annuaire (liste, sans roster complet). */
export const GuildSummarySchema = z.object({
    id: z.number().int(),
    name: z.string(),
    tag: z.string().nullable(),
    ownerName: z.string().nullable(),
    memberCount: z.number().int().nonnegative(),
    level: z.number().int().nonnegative().optional(),
    balance: MoneySchema,
});
//# sourceMappingURL=guild.js.map